module.exports = __webpack_public_path__ + "img/intro-3.ccd8d0eb.jpg";